import styled from "styled-components";

export const ContainerFluid = styled.div`
  background-color: ${(props) => props.theme.bgColor};
  color: ${(props) => props.theme.color};
  border: 5px solid ${(props) => props.theme.color};
  padding: 15px;
  margin-right: auto;
  margin-left: auto;
`;

export const Container = styled.div`
  width: 50%;
  background-color: ${(props) => props.theme.bgColor};
  color: ${(props) => props.theme.color};
  border: 5px solid ${(props) => props.theme.color};
  padding: 15px;
  margin-right: auto;
  margin-left: auto;
`;
export const Div = styled.div`
  text-align: left;
`;
